import { render } from "./TablaComercial.vue?vue&type=template&id=0184560a"
import script from "./TablaComercial.vue?vue&type=script&lang=js"
export * from "./TablaComercial.vue?vue&type=script&lang=js"

import exportComponent from "/home/jean/lienzo/quinta_amelia_dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__